import React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';

const DraggableScrollContainer = props => {
    return (
        <ScrollContainer
            ignoreElements="[draggable], .react-draggable, .field, .multi-line-input, .edit-panel, .field-input"
            hideScrollbars={false}
            {...props}
        />
    );
}

export default DraggableScrollContainer;
